import React from 'react';
import { useEffect, useState } from 'react';
import '../styles.css';
import { getAllTemplatesCountByType, getTemplates,getTemplateInfoById } from 'api/TemaplateApi';
import { useSelector, useDispatch } from 'react-redux';
import {
  setCampaignFlow,
  setCampignTemplateId,
  setBackfromCampaign,
  setisNewCampaignTempateId,
  setCampaignABTestTemplateId
} from 'ReduxStore/Slices/campaignSlice';
import {
  setTemplateId,
  setTemplateParameterId,
  setTemplateLoading,
  setBaseTemplateId
} from 'ReduxStore/Slices/templateSlice';
import SelectTemplateHeader from './SelectTemplateComponent/SelectTemplateHeader';
import SelectTemplateTab from './SelectTemplateComponent/SelectTemplateTab';
import AdvisorLayout from './AdvisorLayout'
import NewEditor from './NewEditor'
import $ from 'jquery';




let layoutTemplateTabOffset = 0;
let layoutTemplateTabNextButton = 1;
let emailTemplateTabOffset = 0;
let emailTemplateTabNextButton = 1;
let savedTemplateTabOffset = 0;
let savedTemplateTabNextButton = 1;
let blogsTemplateTabOffset = 0;
let blogsTemplateTabNextButton = 1;
let calculatorTemplateTabOffset = 0;
let calculatorTemplateTabNextButton = 1;

let offerTemplateTabOffset = 0;
let offerTemplateTabNextButton = 1;

let leadTemplateTabOffset = 0;
let leadTemplateTabNextButton = 1;

export default function SelectTemplate(props) {
  const [templateData, setTemplateData] = useState([]);
  const [newEditor ,setNewEditor] = useState(null)
  const [advisorEditor ,setadvisorEditor] = useState(null)


  const [count, setCount] = useState(null);
  const [returnFromFlow, setReturnFromFlow] = useState(false);
  const userSetter = useSelector((state) => state.userSetter);
  const campaignSetter = useSelector((state) => state.campaignSetter);
  const templateSetter = useSelector((state) => state.templateSetter);
  const dispatch = useDispatch();
  const PER_PAGE = 9;
  const campaignData = useSelector((state) => state.campaignSetter);
  const { role } = useSelector(
    (state) => state.userSetter
  );

  const EMAIL_TEMPLATE_TYPE_TABS = [
    {
      tabId: 'layoutTemplateTab',
      name: 'Layouts',
      id: 'layout',
      status: 'active',
    },
    { tabId: 'emailTemplateTab', name: 'Emails', id: 'emailTheme' },
    { tabId: 'savedTemplateTab', name: 'Saved Templates', id: 'userTemplate' },
  ];


  const ADVISOR_TEMPLATE_TYPE_TABS = [

    {
      tabId: 'layoutTemplateTab',
      name: 'Layouts',
      id: 'layout',
      status: 'active',
    },
    { tabId: 'savedTemplateTab', name: 'Saved Templates', id: 'userTemplate' },
  
  ];

  
  const PUBLISHED_CONTENT_TYPE_TABS = role != 'publisher' ?[
    {
      tabId: 'layoutTemplateTab',
      name: 'Layouts',
      id: 'layout',
      status: (!campaignData.html && campaignData && campaignData.isAdvisor )|| ((!campaignData.html) &&userSetter.userFlow == 'createCampaign' &&role =='publisher')? "" :'active',
    },
    // { tabId: 'blogsTemplateTab', name: 'Blogs', id: 'blog' },
    { tabId: 'calculatorTemplateTab', name: 'Calculators', id: 'calculator' },
    { tabId: 'leadConnect', name: 'Connect Widget', id: 'leadConnect',status:  (!campaignData.html && userSetter.userFlow == 'createCampaign' &&role =='publisher')? 'active':"" },

    // { tabId: 'leadCalc', name: 'Lead Calculators', id: 'leadCalculator' },

    { tabId: 'Offers', name: 'Offers', id: 'offer' },

    // { tabId: 'advisor', name: 'Advisor Connect', id: 'advisorConnect' , status: (campaignData && campaignData.isAdvisor) || (userSetter.userFlow == 'createCampaign' &&role =='publisher')? 'active':""},

    { tabId: 'savedTemplateTab', name: 'Saved Templates', id: 'userTemplate' },
  ] :[
    { tabId: 'leadConnect', name: 'Connect Widget', id: 'leadConnect',status:   'active'}

  ];

  
  const getTotalCount = (type) => {
    getAllTemplatesCountByType(type, "KapitalWise")
      .then((data) => {

        setCount(data);
      })
      .catch(function (error) {

      });
  };

  const getAllTemplates = (templateType, layoutType) => {
    dispatch(setTemplateLoading(true));
    getTemplates(templateType, layoutType, PER_PAGE, 0)
      .then((data) => {
        setTemplateData(data);
        // if (role == 'publisher'){
        //   console.log("IN PPPPPPPPPP")

        //     if(campaignData && campaignData.html)  {
        //       setNewEditor({"grapesjs-react-editorhtml":campaignData.html,  ...campaignData , subCategory:"advisorConnect"})
        //       console.log("IN PPPPPPPPPP  NNNNNNNNNN")

        //       return 

        //     }

        //   let advisorTemplate = data.filter((item)=>item.subCategory == 'advisorConnect')
        //   setNewEditor(advisorTemplate[0])
        // }
        dispatch(setTemplateLoading(false));
      })
      .catch((e) => { })
  };

  const urlToCreateTemplate = (item) => {
    console.log("item  kollllpppppp", item,campaignData)


    if (userSetter.userFlow == 'createCampaign') {
      dispatch(setCampaignFlow(true));
    } else if (userSetter.userFlow == 'createTemplate') {
      dispatch(setCampaignFlow(false));
    }
    if (item?.id == 'offer') {
      props.history.push(`/admin/templates/create?flow=offers`);
      return
    }
    

    if(campaignData && campaignData.html  && campaignData.widgetType){
      setNewEditor({"grapesjs-react-editorhtml":campaignData.html,  ...campaignData})
      console.log("kopppppppppppp",campaignData.html)
      var link = $('a[href="#leadConnect"]').addClass('active');
      $('a[href="#layoutTemplateTab"]').removeClass('active');
      getAllTemplates(campaignSetter.campaignType, 'leadConnect');

    }
    else{
     props.history.push(`/admin/templates/create`);
    }
      console.log("itemlloooooooo", item ,campaignData, "wiftttttttttt",campaignData && !campaignData.isAdvisor && campaignData.widgetType )
  };


  const setTemplateOnTheURL = (key, item) => {
    console.log("KKKKKKKKKKKKKKKKKKKKKK", key, item)

    if (userSetter.userFlow == 'createCampaign') {
      dispatch(setCampaignFlow(true));
      dispatch(setTemplateId(key.template_id));
      dispatch(setBaseTemplateId(key.template_id));
      dispatch(setisNewCampaignTempateId(true));
      // if (campaignSetter.currentABTestCampaign == 'A') {
      //   if (key.template_id !== campaignSetter.campignTemplateId) {
      //     dispatch(setisNewCampaignTempateId(true));
      //   }
      // } else if (campaignSetter.currentABTestCampaign == 'B') {
      //   if (key.template_id !== campaignSetter.campaingABTestData.campaignABTestTemplateId) {
      //     dispatch(setisNewCampaignTempateId(true));
      //   }
      // } else {
      //   dispatch(setisNewCampaignTempateId(false));
      // }
      if (campaignSetter.currentABTestCampaign == 'A') {
        dispatch(setCampignTemplateId(key.template_id));
      } else if (campaignSetter.currentABTestCampaign == 'B') {
        dispatch(setCampaignABTestTemplateId(key.template_id));
      }
      dispatch(setTemplateParameterId(null));
      dispatch(setBackfromCampaign(false));


      var element = $('a[href="#layoutTemplateTab"]');

  // Element exists



      console.log("halo",key,"item",item , $('a[href="#leadConnect"]').hasClass("active") ,)

      if((item &&  item.tabId == 'leadConnect') || $('a[href="#leadConnect"]').hasClass("active") ){
        getTemplateInfoById(key.template_id).then((data) => {
          console.log("data",data)
          setNewEditor(data)
        })
        return
      }
      else{
        setNewEditor(null)
        console.log("else  lll")
      }

      
      if (item?.id == 'offer') {
        props.history.push(`/admin/templates/create?flow=offers`);
        return
      }
      props.history.push(`/admin/templates/create`);
    } else if (userSetter.userFlow == 'createTemplate') {
      dispatch(setBaseTemplateId(key.template_id));
      dispatch(setTemplateId(key.template_id));
      if (returnFromFlow !== true) {
        dispatch(setTemplateParameterId(null));
      }
      if (item?.id == 'offer') {
        props.history.push(`/admin/templates/create?flow=offers`);
        return
      }
      props.history.push(`/admin/templates/create`);
    }
  };

  const PreviousDataShowing = async (e, templateType, layoutType) => {
    e.preventDefault();
    dispatch(setTemplateLoading(true));
    switch (layoutType) {
      case 'layout': {
        layoutTemplateTabOffset = layoutTemplateTabOffset - PER_PAGE;
        getTemplates(
          templateType,
          layoutType,
          PER_PAGE,
          layoutTemplateTabOffset
        )
          .then((data) => {
            layoutTemplateTabNextButton = layoutTemplateTabNextButton - 1;
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'emailTheme': {
        emailTemplateTabOffset = emailTemplateTabOffset - PER_PAGE;
        getTemplates(templateType, layoutType, PER_PAGE, emailTemplateTabOffset)
          .then((data) => {
            emailTemplateTabNextButton = emailTemplateTabNextButton - 1;
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'userTemplate': {
        savedTemplateTabOffset = savedTemplateTabOffset - PER_PAGE;
        getTemplates(templateType, layoutType, PER_PAGE, savedTemplateTabOffset)
          .then((data) => {
            savedTemplateTabNextButton = savedTemplateTabNextButton - 1;
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'blog': {
        blogsTemplateTabOffset = blogsTemplateTabOffset - PER_PAGE;
        getTemplates(templateType, layoutType, PER_PAGE, blogsTemplateTabOffset)
          .then((data) => {
            blogsTemplateTabNextButton = blogsTemplateTabNextButton - 1;
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'calculator': {
        calculatorTemplateTabOffset = calculatorTemplateTabOffset - PER_PAGE;
        getTemplates(
          templateType,
          layoutType,
          PER_PAGE,
          calculatorTemplateTabOffset
        )
          .then((data) => {
            calculatorTemplateTabNextButton =
              calculatorTemplateTabNextButton - 1;
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'offer': {
        offerTemplateTabOffset = offerTemplateTabOffset - PER_PAGE;
        getTemplates(
          templateType,
          layoutType,
          PER_PAGE,
          offerTemplateTabOffset
        )
          .then((data) => {
            offerTemplateTabNextButton =
              offerTemplateTabNextButton - 1;
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'leadConnect': {
        leadTemplateTabOffset = leadTemplateTabOffset - PER_PAGE;
        getTemplates(
          templateType,
          layoutType,
          PER_PAGE,
          leadTemplateTabOffset
        )
          .then((data) => {
            leadTemplateTabNextButton =
              leadTemplateTabNextButton - 1;
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      default:
        return 0;
    }
  };

  const NextDataShowing = async (e, templateType, layoutType) => {
    e.preventDefault();
    dispatch(setTemplateLoading(true));
    switch (layoutType) {
      case 'layout': {
        layoutTemplateTabNextButton = layoutTemplateTabNextButton + 1;
        layoutTemplateTabOffset = layoutTemplateTabOffset + PER_PAGE;
        getTemplates(
          templateType,
          layoutType,
          PER_PAGE,
          layoutTemplateTabOffset
        )
          .then((data) => {
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'emailTheme': {
        emailTemplateTabNextButton = emailTemplateTabNextButton + 1;
        emailTemplateTabOffset = emailTemplateTabOffset + PER_PAGE;
        getTemplates(templateType, layoutType, PER_PAGE, emailTemplateTabOffset)
          .then((data) => {
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'userTemplate': {
        savedTemplateTabNextButton = savedTemplateTabNextButton + 1;
        savedTemplateTabOffset = savedTemplateTabOffset + PER_PAGE;
        getTemplates(templateType, layoutType, PER_PAGE, savedTemplateTabOffset)
          .then((data) => {
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'blog': {
        blogsTemplateTabNextButton = blogsTemplateTabNextButton + 1;
        blogsTemplateTabOffset = blogsTemplateTabOffset + PER_PAGE;
        getTemplates(templateType, layoutType, PER_PAGE, blogsTemplateTabOffset)
          .then((data) => {
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'calculator': {
        calculatorTemplateTabNextButton = calculatorTemplateTabNextButton + 1;
        calculatorTemplateTabOffset = calculatorTemplateTabOffset + PER_PAGE;
        getTemplates(
          templateType,
          layoutType,
          PER_PAGE,
          calculatorTemplateTabOffset
        )
          .then((data) => {
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      case 'offer': {
        offerTemplateTabNextButton = offerTemplateTabNextButton + 1;
        offerTemplateTabOffset = offerTemplateTabOffset + PER_PAGE;
        getTemplates(
          templateType,
          layoutType,
          PER_PAGE,
          offerTemplateTabOffset
        )
          .then((data) => {
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }

      case 'leadConnect': {
        leadTemplateTabNextButton = leadTemplateTabNextButton + 1;
        leadTemplateTabOffset = leadTemplateTabOffset + PER_PAGE;
        getTemplates(
          templateType,
          layoutType,
          PER_PAGE,
          leadTemplateTabOffset
        )
          .then((data) => {
            setTemplateData(data);
            dispatch(setTemplateLoading(false));
          })
          .catch((e) => { })
        break;
      }
      default:
        return 0;
    }
  };

  const getTemplatePageCount = (tab) => {
    switch (tab) {
      case 'layoutTemplateTab':
        return Math.ceil(count?.layoutCount / PER_PAGE);
      case 'emailTemplateTab':
        return Math.ceil(count?.emailThemeCount / PER_PAGE);
      case 'savedTemplateTab':
        return Math.ceil(count?.userTemplateCount / PER_PAGE);
      case 'blogsTemplateTab':
        return Math.ceil(count?.blogCount / PER_PAGE);
      case 'calculatorTemplateTab':
        return Math.ceil(count?.calculatorCount / PER_PAGE);
      case 'Offers':
        return Math.ceil(count?.offerCount / PER_PAGE);
      case 'leadConnect':
        return Math.ceil(count?.leadConnectCount / PER_PAGE);
      default:
        return 0;
    }
  };

  const getTemplateCount = (tab) => {
    switch (tab) {
      case 'layoutTemplateTab':
        return count?.layoutCount;
      case 'emailTemplateTab':
        return count?.emailThemeCount;
      case 'savedTemplateTab':
        return count?.userTemplateCount;
      case 'blogsTemplateTab':
        return count?.blogCount;
      case 'calculatorTemplateTab':
        return count?.calculatorCount;
      case 'Offers':
        return count?.offerCount
      case 'leadConnect':
          return count?.leadConnectCount ;
      default:
        return 0;
    }
  };

  const getTemplateOffsetCount = (tab) => {
    switch (tab) {
      case 'layoutTemplateTab':
        return layoutTemplateTabOffset;
      case 'emailTemplateTab':
        return emailTemplateTabOffset;
      case 'savedTemplateTab':
        return savedTemplateTabOffset;
      case 'blogsTemplateTab':
        return blogsTemplateTabOffset;
      case 'calculatorTemplateTab':
        return calculatorTemplateTabOffset;
      case 'Offers':
        return offerTemplateTabOffset;
        case 'leadConnect':
          return leadTemplateTabOffset;
      default:
        return 0;
    }
  };

  const getTemplateMatchNext = (tab) => {

    switch (tab) {
      case 'layoutTemplateTab':
        return layoutTemplateTabNextButton;
      case 'emailTemplateTab':
        return emailTemplateTabNextButton;
      case 'savedTemplateTab':
        return savedTemplateTabNextButton;
      case 'blogsTemplateTab':
        return blogsTemplateTabNextButton;
      case 'calculatorTemplateTab':
        return calculatorTemplateTabNextButton;
      case 'Offers':
        return offerTemplateTabNextButton;
        case 'leadConnect':
          return leadTemplateTabNextButton;
      default:
        return 0;
    }
  };

  useEffect(() => {
    if (userSetter.userFlow == 'createCampaign') {
      getTotalCount(campaignSetter.campaignType);
      getAllTemplates(campaignSetter.campaignType,role =='publisher'? 'leadConnect':'layout');
    } else if (userSetter.userFlow == 'createTemplate') {
      getTotalCount(templateSetter.templateType);
      getAllTemplates(templateSetter.templateType, 'layout');
    }

    if (
      campaignSetter.backfromCampaign === true ||
      templateSetter.backFromAllTemplates === true
    ) {
      setReturnFromFlow(true);
    } else {
      setReturnFromFlow(false);
    }
  }, []);

  function cancelAdvisorFn(){
    console.log("cancelAdvisorFn")
    setNewEditor(null)
    // if(role =='publisher')
    //   props.history.push(`/admin/campaign/create`)
  }
  return (
    <div className='templates'>
      <SelectTemplateHeader />
      <div className='cmpgn_list_outer'>
        <div className='cmpgn_tab_erap'>

          { <ul className='nav nav-tabs' role='tablist'>
            {(templateSetter.templateType === 'email' ||
              campaignSetter.campaignType === 'email') &&
              EMAIL_TEMPLATE_TYPE_TABS.map((item, index) => {
                return (
                  <li className='nav-item'>
                    <a
                      className={`nav-link ${item.status}`}
                      href={`#${item.tabId}`}
                      role='tab'
                      data-toggle='tab'
                      onClick={() => {
                        if (userSetter.userFlow == 'createTemplate') {
                          getAllTemplates(templateSetter.templateType, item.id);
                        } else if (userSetter.userFlow == 'createCampaign') {
                          getAllTemplates(campaignSetter.campaignType, item.id);
                        }
                      }}
                    >
                      {item.name}
                    </a>
                  </li>
                );
              })}

      {(templateSetter.templateType === 'advisor' ||
              campaignSetter.campaignType === 'advisor') &&
              ADVISOR_TEMPLATE_TYPE_TABS.map((item, index) => {
                return (
                  <li className='nav-item'>
                    <a
                      className={`nav-link ${item.status}`}
                      href={`#${item.tabId}`}
                      role='tab'
                      data-toggle='tab'
                      onClick={() => {
                        if (userSetter.userFlow == 'createTemplate') {
                          getAllTemplates(templateSetter.templateType, item.id);
                        } else if (userSetter.userFlow == 'createCampaign') {
                          getAllTemplates(campaignSetter.campaignType, item.id);
                        }
                      }}
                    >
                      {item.name}
                    </a>
                  </li>
                );
              })}
            {(templateSetter.templateType === 'publishedContent' ||
              campaignSetter.campaignType === 'publishedContent') &&
              PUBLISHED_CONTENT_TYPE_TABS.map((item, index) => {
                if(userSetter.userFlow == 'createTemplate' && item.tabId=='advisor')
                  return ''
                return (
                  <li className='nav-item'>
                    <a
                      className={`nav-link ${item.status}`}
                      href={`#${item.tabId}`}
                      role='tab'
                      data-toggle='tab'
                      onClick={() => {
                        if (userSetter.userFlow == 'createTemplate') {
                          getAllTemplates(templateSetter.templateType, item.id);
                        } else if (userSetter.userFlow == 'createCampaign') {
                          getAllTemplates(campaignSetter.campaignType, item.id);
                        }
                        setNewEditor(false);
                      }}
                    >
                      {item.name}
                    </a>
                  </li>
                );
              })}
          </ul>
          }

          <div className='tab-content'>
            {(templateSetter.templateType === 'email' ||
              campaignSetter.campaignType === 'email') &&
              EMAIL_TEMPLATE_TYPE_TABS.map((item, index) => {
                return (
                  <div
                    role='tabpanel'
                    className={`tab-pane fade in  ${item.status}`}
                    id={`${item.tabId}`}
                  >
                    <SelectTemplateTab
                      id={item.id}
                      tab={item.tabId}
                      loading={templateSetter.templateLoading}
                      templateData={templateData}
                      urlToCreateTemplate={urlToCreateTemplate}
                      setTemplateOnTheURL={setTemplateOnTheURL}
                      templatePageCount={getTemplatePageCount(item.tabId)}
                      templateCount={getTemplateCount(item.tabId)}
                      matchNextButton={getTemplateMatchNext(item.tabId)}
                      offSet={getTemplateOffsetCount(item.tabId)}
                      NextDataShowing={NextDataShowing}
                      PreviousDataShowing={PreviousDataShowing}
                    />
                  </div>
                );
              })}
            {(templateSetter.templateType === 'publishedContent' ||
              campaignSetter.campaignType === 'publishedContent') &&
              PUBLISHED_CONTENT_TYPE_TABS.map((item, index) => {
                if(item.tabId =='advisor'){
                  return                   <div
                  role='tabpanel'
                  className={`tab-pane fade in  ${item.status}`}
                  id={`${item.tabId}`}
                  >
                    {/* <AdvisorLayout   templateData={templateData}   setTemplateOnTheURL={(key) => {  props.history.push(`/admin/campaign/create`) }} /> */}
                  </div>
                }

                else{
                return (<>
                  <div
                    role='tabpanel'
                    className={`tab-pane fade in  ${item.status}`}
                    id={`${item.tabId}`}
                  >
                    {console.log('newEditor',newEditor)}
                    {newEditor ? newEditor.subCategory=='advisorConnect'?  <AdvisorLayout   data= {newEditor}          cancelFn = {cancelAdvisorFn} setTemplateOnTheURL={(key) => {  props.history.push(`/admin/campaign/create`) }} />: <NewEditor      cancelFn = {cancelAdvisorFn} data= {newEditor}  setTemplateOnTheURL={(key) => {  props.history.push(`/admin/campaign/create`) }}/>:<SelectTemplateTab
                      id={item.id}
                      tab={item.tabId}
                      loading={templateSetter.templateLoading}
                      templateData={templateData}
                      urlToCreateTemplate={() => urlToCreateTemplate(item)}
                      setTemplateOnTheURL={(key) => { setTemplateOnTheURL(key, item) }}
                      templatePageCount={getTemplatePageCount(item.tabId)}
                      templateCount={getTemplateCount(item.tabId)}
                      matchNextButton={getTemplateMatchNext(item.tabId)}
                      offSet={getTemplateOffsetCount(item.tabId)}
                      NextDataShowing={NextDataShowing}
                      PreviousDataShowing={PreviousDataShowing}
                    />}
                  </div>


                  </>
                );}

              })}

      {/* {(templateSetter.templateType === 'advisor' ||
              campaignSetter.campaignType === 'advisor') &&
              ADVISOR_TEMPLATE_TYPE_TABS.map((item, index) => {
                return (
                  <div
                    role='tabpanel'
                    className={`tab-pane fade in  ${item.status}`}
                    id={`${item.tabId}`}
                  >
                      <AdvisorLayout/>
                  </div>
                );
              })} */}
          </div>
        </div>
      </div>
    </div>
  );
}
